import { PortfolioEarlyWarning } from "@pages/portfolio/early-warning/early-warning";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/portfolio/early-warning")({
	component: PortfolioEarlyWarning,
});
